export default function ValuePropositionSection() {
  const cards = [
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="17" y1="11" x2="23" y2="11" />
          <line x1="20" y1="8" x2="20" y2="14" />
        </svg>
      ),
      title: 'Clarificar funções e responsabilidades',
      description: 'Ajuda a identificar sobreposições, indefinições funcionais e lacunas de responsabilização que dificultam a execução diária.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
      title: 'Simplificar processos internos',
      description: 'Permite detetar circuitos morosos, redundâncias e oportunidades de melhoria na articulação entre serviços.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
      title: 'Alinhar estrutura e prioridades do executivo',
      description: 'Apoia a adaptação da organização municipal à visão política, estratégica e operacional do mandato.',
    },
    {
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      ),
      title: 'Melhorar desempenho e monitorização',
      description: 'Contribui para criar indicadores, mecanismos de acompanhamento e maior capacidade de execução dos compromissos assumidos.',
    },
  ];

  return (
    <section id="para-que-serve" className="py-20 lg:py-24" style={{ backgroundColor: '#F8F9FA' }}>
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
            <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
              Para que serve
            </span>
          </div>
          <h2
            style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, maxWidth: '36ch', fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '0.875rem', letterSpacing: '-0.02em' }}
          >
            Para que serve?
          </h2>
          <p
            style={{ maxWidth: '56ch', fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.7 }}
          >
            O GP Otimiza intervém nas dimensões que mais condicionam a eficiência interna e a capacidade de execução municipal.
          </p>
        </div>

        {/* 2x2 cards grid */}
        <div className="grid md:grid-cols-2 gap-4">
          {cards?.map((card) => (
            <div
              key={card?.title}
              className="flex gap-5 p-7 bg-white"
              style={{ borderRadius: '6px', border: '1px solid #E5E7EB' }}
            >
              <div
                className="flex items-center justify-center flex-shrink-0"
                style={{ width: '2.5rem', height: '2.5rem', borderRadius: '5px', backgroundColor: 'rgba(0,150,136,0.08)', color: '#009688', border: '1px solid rgba(0,150,136,0.15)' }}
              >
                {card?.icon}
              </div>
              <div>
                <h3
                  style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '1rem', fontWeight: 700, color: '#1a1a1a', marginBottom: '0.4rem', letterSpacing: '-0.01em' }}
                >
                  {card?.title}
                </h3>
                <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#6B7280', lineHeight: 1.7 }}>
                  {card?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}